import { useMutation, useQuery } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IGibUserListRequest {
    taxNumber: string;
}

async function getGibUserList(data: IGibUserListRequest): Promise<any> {
    try {
        const response = await axiosInstance.get(`/Merchant/GetGibUser?taxNumber=${data.taxNumber}`);
        return response.data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetGibUserList() {
    return useMutation<any, Error, IGibUserListRequest>((variables) =>
        getGibUserList(variables)
    );
}